// extracted by mini-css-extract-plugin
export default {"container":"vtpvh_OS947hLJakJ5vK"};